import { render, staticRenderFns } from "./appointHelp.vue?vue&type=template&id=f3b9770a&scoped=true&"
import script from "./appointHelp.vue?vue&type=script&lang=js&"
export * from "./appointHelp.vue?vue&type=script&lang=js&"
import style0 from "./appointHelp.vue?vue&type=style&index=0&id=f3b9770a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b9770a",
  null
  
)

export default component.exports